<template>
  <teleport to="body">
    <div
      v-show="visible"
      class="image-bubble"
      :style="menuStyle"
      @mousedown.prevent
    >
      <button type="button" class="menu-item" :class="{ 'is-active': isAlign('left') }" :title="_('Align left')" @click="setAlign('left')">
        <i class="fa fa-fw fa-align-left"></i>
      </button>
      <button type="button" class="menu-item" :class="{ 'is-active': isAlign('center') }" :title="_('Align center')" @click="setAlign('center')">
        <i class="fa fa-fw fa-align-center"></i>
      </button>
      <button type="button" class="menu-item" :class="{ 'is-active': isAlign('right') }" :title="_('Align right')" @click="setAlign('right')">
        <i class="fa fa-fw fa-align-right"></i>
      </button>
      <div class="image-bubble-divider"></div>
      <button type="button" class="menu-item image-bubble-size" :class="{ 'is-active': isSize('s') }" :title="_('Small')" @click="setSize('s')">S</button>
      <button type="button" class="menu-item image-bubble-size" :class="{ 'is-active': isSize('m') }" :title="_('Medium')" @click="setSize('m')">M</button>
      <button type="button" class="menu-item image-bubble-size" :class="{ 'is-active': isSize('l') }" :title="_('Large')" @click="setSize('l')">L</button>
    </div>
  </teleport>
</template>

<script>
import { johkuEmbedClass, johkuEmbedSize } from '~/lib/tiptap/johkuEmbedImage'

const MENU_HEIGHT = 40

export default {
  props: {
    editor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      visible: false,
      menuRevision: 0,
      menuStyle: {
        position: 'fixed',
        top: '0px',
        left: '0px',
        zIndex: 10050,
      },
    }
  },
  methods: {
    imageAttrs() {
      this.menuRevision
      return this.editor.getAttributes('image') || {}
    },
    isAlign(align) {
      return this.imageAttrs().align === align
    },
    isSize(size) {
      return johkuEmbedSize(this.imageAttrs().size) === size
    },
    setAlign(align) {
      const size = johkuEmbedSize(this.imageAttrs().size)
      this.editor.chain().focus().updateAttributes('image', {
        align,
        size,
        class: johkuEmbedClass(align, size),
      }).run()
      this.$nextTick(this.updateMenu)
    },
    setSize(size) {
      const align = this.imageAttrs().align || 'left'
      this.editor.chain().focus().updateAttributes('image', {
        align,
        size,
        class: johkuEmbedClass(align, size),
      }).run()
      this.$nextTick(this.updateMenu)
    },
    selectedImageEl() {
      const { selection, doc } = this.editor.state
      const node = doc.nodeAt(selection.from)
      if (!node || node.type.name !== 'image') {
        return null
      }
      const dom = this.editor.view.nodeDOM(selection.from)
      return dom instanceof Element ? dom : null
    },
    updateMenu() {
      this.menuRevision++
      if (!this.editor.isActive('image')) {
        this.visible = false
        return
      }
      const el = this.selectedImageEl()
      if (!el) {
        this.visible = false
        return
      }
      const rect = el.getBoundingClientRect()
      if (!rect.width && !rect.height) {
        this.visible = false
        return
      }
      const top = rect.top >= MENU_HEIGHT + 8
        ? rect.top - MENU_HEIGHT
        : rect.bottom + 8
      this.menuStyle = {
        position: 'fixed',
        top: `${Math.round(top)}px`,
        left: `${Math.round(rect.left)}px`,
        zIndex: 10050,
      }
      this.visible = true
    },
  },
  mounted() {
    this.editor.on('selectionUpdate', this.updateMenu)
    this.editor.on('transaction', this.updateMenu)
    window.addEventListener('scroll', this.updateMenu, true)
    window.addEventListener('resize', this.updateMenu)
    this.updateMenu()
  },
  beforeUnmount() {
    this.editor.off('selectionUpdate', this.updateMenu)
    this.editor.off('transaction', this.updateMenu)
    window.removeEventListener('scroll', this.updateMenu, true)
    window.removeEventListener('resize', this.updateMenu)
  },
}
</script>

<style>
.image-bubble {
  display: flex;
  align-items: center;
  padding: 0.2rem;
  background: #fff;
  border: 1px solid #cfd8dc;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}
.image-bubble-divider {
  width: 1px;
  height: 1.25rem;
  background-color: #bcbcbc;
  margin: 0 0.35rem;
}
.image-bubble .menu-item {
  width: 1.75rem;
  height: 1.75rem;
  color: #0D0D0D;
  border: 1px solid transparent;
  background-color: transparent;
  border-radius: 0;
  padding: 0.25rem;
  margin-right: 0.15rem;
  cursor: pointer;
}
.image-bubble .menu-item.is-active,
.image-bubble .menu-item:hover {
  background-color: #e5e5e5;
  border: 1px #bcbcbc solid;
}
.image-bubble-size {
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1;
}
</style>
